import { ActivityUpdateItem } from '../types/types'

export const updateTimelineItemByItemId = (
  newDataItem: ActivityUpdateItem,
  timelineItems,
  timelineDates,
) => {
  const indexScope = timelineDates?.findIndex(dateItem => dateItem == newDataItem.date)
  if (indexScope === -1 || indexScope === undefined) {
    return timelineItems
  }

  if (!newDataItem.type) {
    return timelineItems
  }

  timelineItems[indexScope].items?.forEach(currentActivityItem => {
    if (currentActivityItem.type === newDataItem.type) {
      const currentItemId = currentActivityItem.data?.id || currentActivityItem.id
      const newItemId = newDataItem.data?.id

      // Сравниваем ID только если они оба определены
      if (newItemId && currentItemId && currentItemId === newItemId) {
        // Обновляем data, если оно передано
        if (newDataItem.data) {
          currentActivityItem.data = { ...currentActivityItem.data, ...newDataItem.data }
        }
        // Обновляем date, если оно передано
        if (newDataItem.date !== undefined) {
          currentActivityItem.date = newDataItem.date as any
        }
      }
    }
  })
  return timelineItems
}
